import React, { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { apiClient } from '../../api/client';

const AffirmationCard = () => {
  const [affirmation, setAffirmation] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    apiClient.request('/api/enhancements/affirmation')
      .then(data => {
        setAffirmation(data);
        setTimeout(() => setVisible(true), 100);
      })
      .catch(() => {});
  }, []);

  if (!affirmation) return null;

  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-r from-amber-50 via-orange-50 to-rose-50 border border-amber-200/60 p-5 rounded-xl shadow-sm transition-all duration-700 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
      }`}
      data-testid="affirmation-card"
    >
      <div className="flex items-start gap-3">
        <div className="p-2 bg-amber-100 rounded-lg flex-shrink-0">
          <Sparkles size={18} className="text-amber-600" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-amber-800/60 mb-1">Daily Affirmation</p>
          <p className="text-gray-900 font-medium leading-relaxed">{affirmation.message}</p>
        </div>
      </div>
      {/* Decorative element */}
      <div className="absolute -right-4 -bottom-4 w-20 h-20 bg-amber-200/20 rounded-full" />
    </div>
  );
};

export default AffirmationCard;
